import { getScrollEventTarget, getScrollTop, scrollTo, scrollContainerMediaQuery } from '@theme/scroll-container';

class BackToTopButton extends HTMLElement {
  #threshold = 400;
  #ticking = false;
  #target = null;

  connectedCallback() {
    this.#bindScrollTarget();
    scrollContainerMediaQuery.addEventListener('change', this.#handleBreakpointChange);
    this.querySelector('.back-to-top__button')?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#target?.removeEventListener('scroll', this.#handleScroll);
    scrollContainerMediaQuery.removeEventListener('change', this.#handleBreakpointChange);
  }

  #bindScrollTarget() {
    // The scroll container swaps at the 990px breakpoint (.page-wrapper on
    // desktop, the document on mobile) - rebind on every crossing instead of
    // listening on both unconditionally.
    this.#target?.removeEventListener('scroll', this.#handleScroll);
    this.#target = getScrollEventTarget();
    this.#target.addEventListener('scroll', this.#handleScroll, { passive: true });
    this.#handleScroll();
  }

  #handleBreakpointChange = () => this.#bindScrollTarget();

  #handleScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#ticking = false;
      this.dataset.visible = getScrollTop() > this.#threshold ? 'true' : 'false';
    });
  };

  #handleClick = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };
}

customElements.define('back-to-top-button', BackToTopButton);
